export function showHellobar(show, helloBarCookie) {
	if (show) {
		document.body.classList.add('hellobar--visible');

		const adminBarEl = document.querySelector('#wpadminbar');
		const helloBarEl = document.querySelector('.hellobar');

		if (
			document.body.classList.contains('hellobar--position-top') &&
			adminBarEl &&
			helloBarEl
		) {
			helloBarEl.style.top = adminBarEl.offsetHeight + 'px';
		}
	} else {
		document.body.classList.remove('hellobar--visible');
		helloBarCookie.set(1);
	}

	window.dispatchEvent(new CustomEvent('hellobar-visible', { detail: show }));
}

export function addScrollWatcher(distance) {
	const scrollCallback = () => {
		const curDistance =
			window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

		if (curDistance >= distance) {
			showHellobar(true);
			window.removeEventListener('scroll', scrollCallback);
		}
	};

	window.addEventListener('scroll', scrollCallback);
}

export function addTimeoutWatcher(timeout) {
	setTimeout(() => {
		showHellobar(true);
	}, timeout);
}
